<template>
  <div class="image">
    <img :src="src" :style="inputStyle" />
  </div>
</template>

<script>
export default {
  name: 'MyImage',
   props: ['src', 'width', 'height'],
   computed: {
     inputStyle () {
       return {
         width: this.width,
         height: this.height
       }
     }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .image{
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
